export const GET_REDIRECT_URL = 'GET_REDIRECT_URL';

export const getRedirectUrl = (success, failure) => {
    return {
        type: GET_REDIRECT_URL,
        success,
        failure
    };
};